module.exports = __webpack_public_path__ + "bad476d55d2c9f1d3741ba57569dbddf.woff2";